export default __webpack_public_path__ + "static/media/icon-reglage-haut_droite.58160f54.svg";